<template>
  <div class="register">
    <v-stepper class="stepper" v-model="selectedStep" dark>
      <!-- <h2>Registrierungsfortschritt</h2> -->
      <v-stepper-header>
        <v-stepper-step color="green" step="1">Persönliches</v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step color="green" step="2">Profilbild</v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step color="green" step="3">Spielerdaten</v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step color="green" step="4" complete>Status</v-stepper-step>
      </v-stepper-header>
      <v-stepper-items class="items">
        <v-stepper-content class="content" step="1">
          <h1>
            Damit wir passende Vereine für <span class="green-text">dich</span> finden
            können, benötigen wir noch einige wichtige Infos von dir.
          </h1>

          <hr class="green-line" />

          <label>
            Geburtsdatum
            <span>*</span>
          </label>
          <v-menu
            ref="menu"
            v-model="menu"
            locale="de"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            full-width
            color="green"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                color="green"
                v-model="user_data.birthday"
                prepend-icon="event"
                readonly
                solo
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              color="green"
              ref="picker"
              locale="de"
              v-model="user_data.birthday"
              :max="new Date().toISOString().substr(0, 10)"
              min="1900-01-01"
            ></v-date-picker>
          </v-menu>

          <label>
            Geschlecht
            <span>*</span>
          </label>
          <v-select
            color="green"
            :items="sex"
            v-model="user_data.gender"
            solo
          ></v-select>

          <label>Größe in cm<span>*</span></label>
          <div class="px-4">
            <v-slider
              color="green"
              v-model="user_data.size"
              min="50"
              max="220"
              thumb-label
              :always-dirty="true"
            ></v-slider>
          </div>

          <label>Gewicht in kg <span>*</span></label>
          <div class="px-4">
            <v-slider
              color="green"
              v-model="user_data.weight"
              min="50"
              max="120"
              thumb-label
              :always-dirty="true"
            ></v-slider>
          </div>

          <label> Nationalität <span>*</span> </label>
          <v-select
            v-model="user_data.nationality"
            :items="$store.state.nationalities"
            item-text="item_text"
            item-value="id"
            color="green"
            solo
          >
            <template v-slot:item="slotProps">
              <i
                :class="['mr-2', 'em', `em-flag-${slotProps.item.id.toLowerCase()}`]"
              ></i>
              {{ slotProps.item.item_text }}
            </template>
          </v-select>

          <label>Sprachen <span>*</span></label>
          <v-select
            solo
            v-model="user_data.languages"
            color="green"
            :items="$store.state.languages"
            chips
            multiple
          ></v-select>

          <label class="middle_header">Aktueller Wohnsitz <span>*</span></label>

          <!-- <label>Postleitzahl <span>*</span></label> -->
          <v-text-field
            color="green"
            v-model="user_data.zip_code"
            mask="#####"
            placeholder="Postleitzahl"
            solo
          ></v-text-field>

          <!-- <label>Ort, Bundesland</label> -->
          <v-text-field
            color="green"
            v-model="user_data.ort_bundesland"
            placeholder="Ort, Bundesland"
            solo
          ></v-text-field>

          <!-- <label>
            Wohnsitz (Land)
            <span>*</span>
          </label> -->
          <v-autocomplete
            color="green"
            :items="$store.state.countries.filter((c) => c === 'Deutschland')"
            v-model="user_data.place_of_living"
            placeholder="Land"
            disabled
            solo
          ></v-autocomplete>

          <v-btn
            color="green white--text"
            :disabled="
              !user_data.birthday ||
              !user_data.gender ||
              !user_data.size ||
              !user_data.weight ||
              !(user_data.languages && user_data.languages.length) ||
              !user_data.nationality ||
              !user_data.place_of_living ||
              !user_data.zip_code ||
              !user_data.ort_bundesland
            "
            @click="next"
            >Weiter</v-btn
          >
        </v-stepper-content>

        <v-stepper-content class="content" step="2">
          <div v-if="user_data.big_thumbnail" class="upload-change-wrapper">
            <img
              class="register-avatar register-avatar__big"
              :src="user_data.big_thumbnail"
              alt=""
            />
            <label class="upload-label" for="upload-photo"
              ><b class="green-text">Profilbild</b> hochladen</label
            >
            <input
              class="upload-file-input"
              @change="croppie"
              type="file"
              accept="image/*"
              name="photo"
              id="upload-photo"
            />
          </div>
          <div v-else class="upload-wrapper">
            <label class="upload-label" for="upload-photo"
              ><b class="green-text">Profilbild</b> hochladen</label
            >
            <input
              class="upload-file-input"
              @change="croppie"
              type="file"
              accept="image/*"
              name="photo"
              id="upload-photo"
            />
          </div>

          <br />
          <v-btn color="white green--text" @click="back" text>Zurück</v-btn>
          <v-btn color="green white--text" :disabled="!imageSrc" @click="next"
            >Weiter</v-btn
          >
        </v-stepper-content>

        <v-stepper-content class="content" step="3">
          <label>
            Position
            <span>*</span>
          </label>
          <v-select
            color="green"
            @change="setSpecificPosition(user_data.position)"
            :items="$store.state.positions"
            v-model="user_data.position"
            solo
          ></v-select>

          <label v-if="user_data.position && user_data.position !== 'Torhüter'">
            Hauptposition ({{ user_data.position ? user_data.position : 'spezifisch' }})
            <span>*</span>
          </label>

          <v-select
            v-if="user_data.position && user_data.position !== 'Torhüter'"
            color="green"
            :items="playerSpecificPosition"
            v-model="user_data.position_specific"
            solo
          ></v-select>

          <label>
            Nebenposition
            <span>*</span>
          </label>
          <v-select
            color="green"
            :items="$store.state.secondPositions"
            v-model="user_data.secondPosition"
            @change="setSpecificSecondPosition(user_data.secondPosition)"
            solo
          ></v-select>

          <div
            v-if="
              user_data.secondPosition &&
              !$store.state.positionsWithoutSpecific.includes(user_data.secondPosition)
            "
          >
            <label
              >Nebenposition ({{
                user_data.secondPosition ? user_data.secondPosition : 'spezifisch'
              }})</label
            >
            <v-select
              color="green"
              :items="playerSpecificSecondPosition"
              v-model="user_data.second_position_specific"
              solo
            ></v-select>
          </div>

          <label>Spielertyp <span>*</span></label>
          <v-select
            color="green"
            multiple
            :items="player_types"
            v-on:input="limiter"
            v-model="user_data.player_type"
            solo
          ></v-select>

          <label>Bevorzugter Fuß<span>*</span></label>
          <v-select
            color="green"
            :items="foot"
            v-model="user_data.foot"
            solo
          ></v-select>

          <v-btn color="white green--text" @click="back" text>Zurück</v-btn>
          <v-btn
            color="green white--text"
            :disabled="
              !user_data.foot ||
              !user_data.position ||
              (user_data.position !== 'Torhüter' && !user_data.position_specific) ||
              !user_data.secondPosition ||
              !user_data.player_type
            "
            @click="next"
            >Weiter</v-btn
          >
        </v-stepper-content>

        <v-stepper-content class="content" step="4">
          <div class="row">
            <div style="display: inline-block">
              <v-switch
                color="green"
                v-model="user_data.no_team"
                :label="user_data.no_team ? 'Aktiver Spieler' : 'Vereinsloser Spieler'"
              ></v-switch>
            </div>
            <label>
              <span v-if="user_data.no_team">Aktueller</span>
              <span v-else>Letzter</span>
              Verein
              <span>*</span>
            </label>
          </div>
          <v-text-field
            color="green"
            v-model="user_data.currentTeam"
            solo
          ></v-text-field>

          <label>
            Region/Verband
            <span>*</span>
          </label>
          <v-select
            color="green"
            :items="$store.state.verband"
            v-model="user_data.verband"
            solo
          ></v-select>

          <label v-if="user_data.verband">Liga <span>*</span></label>
          <v-select
            v-if="user_data.verband"
            color="green"
            :items="$store.state.filter_leagues[user_data.verband]"
            item-text="league"
            item-value="category"
            return-object
            v-model="user_data.category"
            solo
          ></v-select>
          <v-btn color="white green--text" @click="back" text>Zurück</v-btn>
          <v-btn
            color="green white--text"
            @click="updateData()"
            :loading="loading"
            :disabled="
              !user_data.verband || !user_data.currentTeam || !user_data.category
            "
            >LET'S GO!</v-btn
          >
        </v-stepper-content>

        <!-- <v-stepper-content class="content" step="6">
          <h1 style="color: green; margin: 20px; 0">
            Glückwunsch, deine Registrierung war erfolgreich.
          </h1>
          <h3 style="color: black; margin-bottom: 10px;">
            Jetzt fehlt nur noch die offizielle Verifizierung deines Accounts, um den begehrten blauen C4T-Ring zu erhalten!
          </h3>
          <h3>
            Geh dazu bitte in dein E-Mail Postfach und bestätige per blauen Button deine angegebene E-Mail Adresse.
          </h3>

          <hr class="green-line">

          <p>
            Hinweis: Solltest du keine E-Mail erhalten haben, dann schau bitte auch in deinem SPAM-Ordner nach.
          </p>
          <h3 class="middle_header">
            Vielen Dank für deine Registrierung,<br />dein C4T-Team
          </h3>

          <v-btn color="green white--text" @click="toLogin()">Zum Login</v-btn>
        </v-stepper-content> -->
      </v-stepper-items>
    </v-stepper>

    <CroppieDialog
      ref="croppieDialog"
      :image="imageSrc"
      :show.sync="showCroppie"
      @upload="cropRegistrationAvatar"
    />
  </div>
</template>

<script>
import { db } from '@/db';
import croppieMixin from '../../mixins/croppie';
import commonMixin from '../../mixins/common';
import pushMixin from '../../mixins/push-notifications';
import registerMixin from '../../mixins/register';
import CroppieDialog from '../../components/dialogs/CroppieDialog';

export default {
  name: 'register-player',

  data: () => ({
    checkbox_anb: false,
    checkbox_datenschutz: false,
    menu: false,
    selectedStep: 1,
    date: null,
    loading: false,
    email: '',
    name: '',
    password: '',
    picture: '',
    uploading: false,
    select: { state: 'Florida', abbr: 'FL' },
    landkreis: ['Ohrekreis', 'Salzlandkreis', ''],
    player_types: [
      'Führungsspieler',
      'Harter Spieler',
      'Ballgewinner',
      'Geht lange Wege',
      'Spieleröffner',
      'Spielzerstörer',
      'Sechser',
      'Achter',
      'Zehner',
      'Freistoßexperte',
      'Einfache Pässe',
      'Dribbler',
      'Sturmtank',
      'Ballhalter',
      'Torjäger',
    ],
    items: ['Profi', 'Amateur', 'Halbprofi'],
    foot: ['Rechts', 'Links', 'Beide'],
    sex: ['Männlich', 'Weiblich'],
    showPW: false,
    rules: {
      required: (value) => !!value || '*Pflichtfeld.',
      min: (v) => v.length >= 8 || '*min. 8 Zeichen',
    },
  }),

  components: {
    CroppieDialog,
  },

  mixins: [croppieMixin, pushMixin, registerMixin, commonMixin],

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'));
    },
  },

  computed: {
    playerSpecificPosition() {
      if (this.user_data.position === 'Angriff') {
        return this.$store.state.strikerTypes;
      }
      if (this.user_data.position === 'Verteidiger') {
        return this.$store.state.guardTypes;
      }
      if (this.user_data.position === 'Mittelfeld') {
        return this.$store.state.midfieldType;
      }
      return [];
    },
    playerSpecificSecondPosition() {
      if (this.user_data.secondPosition === 'Angriff') {
        return this.$store.state.strikerTypes;
      }
      if (this.user_data.secondPosition === 'Verteidiger') {
        return this.$store.state.guardTypes;
      }
      if (this.user_data.secondPosition === 'Mittelfeld') {
        return this.$store.state.midfieldType;
      }
      return [];
    },
  },
  methods: {
    next() {
      this.selectedStep++;
      this.$gtm.push({
        event: 'registration',
        registration_progress: `step ${this.selectedStep}`,
        registration_category: 'fullyRegisterPlayer',
      });
      window.scrollTo(0, 0);
    },
    back() {
      this.selectedStep--;
      this.$gtm.push({
        event: 'registration',
        registration_progress: `step ${this.selectedStep}`,
        registration_category: 'fullyRegisterPlayer',
      });
      window.scrollTo(0, 0);
    },
    setSpecificPosition(position) {
      this.$set(this.user_data, 'position_specific', null);
      if (position === 'Torhüter') {
        this.user_data.position_specific = 'Torhüter';
      }
    },
    setSpecificSecondPosition(position) {
      this.$set(this.user_data, 'second_position_specific', null);
      if (position === 'Torhüter') {
        this.$set(this.user_data, 'second_position_specific', 'Torhüter');
      }
    },
    limiter(e) {
      if (e.length > 3) {
        e.pop();
        this.$store.commit({
          type: 'openSnackbar',
          text: 'Maximal 3 Spielertypen',
        });
      }
    },

    updateData() {
      this.clearLinks();

      this.loading = true;

      const nationality = this.$store.state.nationalities.find(
        (n) => n.item_text === this.user_data.place_of_living,
      );
      this.user_data.search_nationality = nationality.id;
      this.user_data.fullyFilled = true;

      db.collection('users')
        .doc(this.user_data.id)
        .update({ ...this.user_data })
        .then(() => {
          this.$gtm.push({
            event: 'registration',
            registration_progress: 'success',
            registration_category: 'fullyRegisterPlayer',
          });
          this.$router.push({ name: 'home' });
        });
    },
  },

  beforeMount() {
    this.$gtm.push({
      event: 'registration_full_start',
      registration_progress: 'start',
      registration_category: 'fullyRegisterPlayer',
    });
  },
  mounted() {
    this.user_data.place_of_living = 'Deutschland';
    this.user_data.size = 180;

    window.addEventListener('beforeunload', (e) => {
      // Cancel the event
      e.preventDefault();
      // Chrome requires returnValue to be set
      e.returnValue = '';
    });
  },
};
</script>

<style lang="scss">
@import '@/styles/register.scss';
</style>
